import React, { useState } from "react";
import { Modal } from "antd";
import { useIntl } from "react-intl";
import { LicenseKey } from "services/rest/subscription";
import { DateUtils } from "services/utils/DateUtils";
import { StoreTable } from "toolkit/table/StoreTable";
import { ColumnsType } from "antd/es/table";

export type LicenseKeysModalProps = {
  visible: boolean,
  onOk: (keys: LicenseKeyRow[]) => void,
  onCancel: () => void,
  licenseKeysProps?: LicenseKey[],
}

export type LicenseKeyRow = {
  key: string,
  id: string,
  licenseKey: string,
  startedOn: string,
  expireOn: string,
}

export function LicenseKeysModal(props: LicenseKeysModalProps) {
  const { visible,licenseKeysProps , onOk, onCancel } = props;
  const intl = useIntl();
  const [licenseKeys, setLicenseKeys] = useState<LicenseKeyRow[]>([]);

  const columns: ColumnsType = [
    {
      title: intl.formatMessage({ id: "jmix-store.license-keys-to-delete-modal.column.license-key" }),
      dataIndex: "licenseKey",
      key: "licenseKey",
    },
    {
      title: intl.formatMessage({ id: "jmix-store.license-keys-to-delete-modal.column.started-on" }),
      dataIndex: "startedOn",
      key: "startedOn",
    },
    {
      title: intl.formatMessage({ id: "jmix-store.license-keys-to-delete-modal.column.expire-on" }),
      dataIndex: "expireOn",
      key: "expireOn",
    },
  ];


  const dataSource = licenseKeysProps?.map(key => {
    return {
      key: key.id,
      id: key.id,
      licenseKey: key.sid,
      startedOn: DateUtils.getFormatDate(key.startDate),
      expireOn: DateUtils.getFormatDate(key.endDate),
    };
  });

  return (
    <Modal
      centered
      destroyOnClose={true}
      width="800px"
      title={intl.formatMessage({ id: "jmix-store.subscription-modal.title" })}
      visible={visible}
      onOk={() => onOk(licenseKeys)}
      onCancel={onCancel}

      okText={intl.formatMessage({ id: "jmix-store.subscription-modal.ok-text" })}
    >
      <StoreTable
        rowSelection={{
          type: "checkbox",
          onChange: (selectedRowKeys: React.Key[], selectedRows: LicenseKeyRow[]) => {
            setLicenseKeys(selectedRows);
          },
        }}
        columns={columns}
        dataSource={dataSource}
      />
    </Modal>
  );
}